import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'projects-directory-v3.page-layout.no-permission-views.no-projects.header',
		defaultMessage: 'You currently have no projects',
		description: 'Projects Directory global empty state heading',
	},
	description: {
		id: 'projects-directory-v3.page-layout.no-permission-views.no-projects.description',
		defaultMessage: "Let's create your first project in Jira",
		description: 'Projects Directory global empty state description',
	},
	createProject: {
		id: 'projects-directory-v3.page-layout.no-permission-views.no-projects.create-project',
		defaultMessage: 'Create project',
		description: 'Projects Directory global empty state create project button, call for action',
	},
});
